import type { FaireProductEntity } from "../../entity_types/product";

export const p_ywvg6kpqgh: FaireProductEntity = {
  token: "p_ywvg6kpqgh",
  type: "product",
  name: "Gold Enamel red XOXO Heart Charms for Jewelry Making",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/0c69e032a7da3f6d084466dc4a08d3e48252e875fd1eb5e8a911d444391148f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/25868fc59932c161ea8946f379f398d33cab42f952b2cb9298a89f545dc8dbd8.jpeg",
    "https://cdn.faire.com/fastly/6c6121d38ab9b99a2619aa195ea0d70666d2fae5e725736dade8f9125d5d6697.jpeg",
    "https://cdn.faire.com/fastly/c3169df9e442bb8de09178960028f8a9e81dba9799e79fa87095cb93f9083061.jpeg",
    "https://cdn.faire.com/fastly/514c34bb47283aef17322bb26cb9890be37f6e9fcc004d1597c5578e3d6699c7.jpeg",
    "https://cdn.faire.com/fastly/c0115b86250a7de554ca0cdf461af51e046d015b9b435dba80add30c8c9e35c2.jpeg",
    "https://cdn.faire.com/fastly/4f265c16569bb94735f288079fd110e272962fed22374e3e74b4187b8574984a.jpeg",
    "https://cdn.faire.com/fastly/ea1ed7650b27e7f343331cfa41f0f1e83fb131be11669cc6fe4a6f3c151a70e7.jpeg",
  ],
  priceDollars: 2.76,
  description:
    "XOXO Hugs And Kisses Red Enamel Gold Heart Charm For Jewelry Making,Polished Shiny Finished,CPG2641\nListing is for one Single piece\n14K Gold Plated And Coated With Red And White Enamel\nMeasurements:15.8mm x 13.7mm\nThickness:2.4mm\nOpen Jump ring:3.5mm\nAll Sizes Are Approximate\nlead, Cadmium and Nickel Free\nQuantity discount available at drop down menu\nFor any questions or concerns feel free to send us a message.\n\nShip From Los Angeles",
  tags: [],
  msrpDollars: 5.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:59.437Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
